import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'

import { filterInformations } from '../utils/filterInformations'
import { storedEnv } from '../utils/localStorage'
import MaisConteudoAPi from '../services/MaisConteudoAPi';

interface IFilterContext {
    colorsBrandMemo: {
        filterItemName: string;
        filterItemValue: string;
    }[],
    sizesBrandMemo: {
        filterItemName: string;
        filterItemValue: string;
    }[],
    categorysBrandMemo: {
        filterItemName: string;
        filterItemValue: string;
        name: string;
    }[],
    setAttributeHandler: (newAttribute: any) => void;
}

type Category = {
    name: string;
    id: number;
    children: {
        children: any; id: number; name: string
    }[];
};

export const FilterContext = createContext({} as IFilterContext);

const FilterContextProvider: React.FC = ({ children }) => {
    const [data, setData] = useState<Category[]>([]);
    const [filterProps, setFilterProps] = useState('');

    const onGetDataFilterHandler = useCallback(async () => {
        try {
            const res = await MaisConteudoAPi.get(`/v1/products/categories/${storedEnv}`)
            setData(res.data)
        } catch (error: any) {
            console.log(error.response?.data.message || 'Algo de errado aconteceu, tente novamente!')
        }
    }, [])

    const setAttributeHandler = useCallback((newAttribute) => {
        setFilterProps(newAttribute);
    }, []);

    useEffect(() => {
        onGetDataFilterHandler()
    }, [onGetDataFilterHandler])

    const colorsBrandMemo = useMemo(() => (
        filterInformations.colorsItems.filter(brand => brand.vtexName === storedEnv)
            .flatMap(item => item.colors)
            .map(color => ({ filterItemName: color.filterItemName, filterItemValue: color.filterItemValue }))
    ), [])

    const sizesBrandMemo = useMemo(() => (
        filterInformations.sizeItems.filter(brand => brand.vtexName === storedEnv)
            .flatMap(item => item.size)
            .map(size => ({ filterItemName: size.filterItemName, filterItemValue: size.filterItemValue }))
    ), [])

    const categorysBrandMemo = useMemo(() => {
        if (filterProps === 'bazar') {
            const parent = data.find(parent => parent.id === 2);
            if (parent) {
                return parent.children.map(child => ({
                    filterItemName: child.name,
                    filterItemValue: child.id.toString(),
                    name: parent.name,
                    id: parent.id
                }));
            } else {
                return [];
            }
        }
        return data.flatMap(parent => {
            if (parent.id === 2) {
                return [];
            }
            if (parent.id === 60) {
                return parent.children.flatMap(child =>
                    child.children.map((grandchild: { name: string; id: { toString: () => any; }; }) => ({
                        filterItemName: grandchild.name,
                        filterItemValue: `${child.id}/${grandchild.id}`,
                        name: child.name,
                        id: parent.id
                    }))
                );
            }
            return parent.children.map(child => ({
                filterItemName: child.name,
                filterItemValue: child.id.toString(),
                name: parent.name,
                id: parent.id
            }));
        });
    }, [data, filterProps]);

    return (
        <FilterContext.Provider value={{
            colorsBrandMemo,
            sizesBrandMemo,
            categorysBrandMemo,
            setAttributeHandler
        }}>
            {children}
        </FilterContext.Provider>
    )
}

const useFilter = () => {
    const context = useContext(FilterContext)
    return { ...context }
}

export default useFilter

export { FilterContextProvider }
